import { render, staticRenderFns } from "./member_label.vue?vue&type=template&id=8bf6f350&scoped=true"
import script from "./member_label.vue?vue&type=script&lang=js"
export * from "./member_label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf6f350",
  null
  
)

export default component.exports